// extracted by mini-css-extract-plugin
module.exports = {"scoreLine":"e_iy","scoreRing":"e_jy","badge":"e_ky","badgeImage":"e_ly","spaced":"e_my"};